/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal, Table } from "semantic-ui-react";
import { TextField } from "@mui/material";
import { selectCurrentUserApiToken, selectCurrentUserName, selectSseConnectionId } from "../../slices/currentUser/currentUserSlice.js";
import { selectViewingOlderVersion } from "../../slices/viewingOlderVersion/viewingOlderVersionSlice.js";
import { globalLoadingOff, globalLoadingOn } from "../../slices/globalLoading/globalLoadingSlice.js";
import { baselineRiskAdded, baselineRiskUpdated, selectAllBaselineRisks } from "../../slices/baselineRisk/baselineRiskSlice.js";
import { selectAllOutcomeVariables } from "../../slices/outcomeVariables/outcomeVariablesSlice.js";
import updateFhirJson from "../../functions/updateFhirJsonAPI.js";
import submitFhirJson from "../../functions/submitFhirJsonAPI.js";
import getFoiFromFli from "../../functions/getFoiFromFliAPI.js";
import { handleWheel, handleKeyDown } from "../../functions/eventHandlers";
import { codeMatchesPercentage, codeMatchesProportion } from "../compositionResourceFunctions/summaryOfFindingsFunctions.js";

const updateResourceWithModifiedRisks = (resource, modifiedRisk) => {
    resource.statistic = resource.statistic.map(statistic => {
        if (statistic.statisticType?.coding?.length > 0 &&
            codeMatchesProportion(statistic.statisticType.coding[0].code)) {
            statistic.quantity.value = modifiedRisk;
        }
        if (statistic.statisticType?.coding?.length > 0 &&
            codeMatchesPercentage(statistic.statisticType.coding[0].code)) {
            statistic.quantity.value = modifiedRisk * 100;
        }
        return statistic;
    })
    return resource;
};

const ModifiedRiskEntry = ({ fieldLabel, targetfoi, startingValue,
    setChangeBaselineRatesWorkState, setChangeAvailableToSaveState }) => {

    return <div>
        <TextField style={{ width: "100%", marginTop: "16px", maxWidth: "150px" }}
            className="inputField" type='number' inputMode='numeric' label={fieldLabel} size="small" variant='outlined'
            value={startingValue || ""}
            onWheel={handleWheel}
            onKeyDown={handleKeyDown}
            onChange={(e) => {
                setChangeBaselineRatesWorkState(prevState => {
                    let newDictionary = JSON.parse(JSON.stringify(prevState));
                    for (let key in newDictionary) {
                        if (newDictionary[key].defaultRisk === null) {
                            newDictionary[key].defaultRisk = NaN;
                        }
                    }
                    newDictionary[targetfoi]["modifiedRisk"] = parseFloat(e.target.value) / 100;
                    newDictionary[targetfoi]["itemChanged"] = true;
                    return newDictionary;
                });
                setChangeAvailableToSaveState(true);
            }} />
        <>%</>
    </div>
};

const ChangeBaselineRatesTable = ({ changeBaselineRatesWorkState, setChangeBaselineRatesWorkState,
    setChangeAvailableToSaveState }) => {

    const baselineRiskResources = useSelector(state => selectAllBaselineRisks(state));
    const outcomeVariables = useSelector(state => selectAllOutcomeVariables(state));

    return <>
        {(baselineRiskResources && Object.keys(baselineRiskResources).length > 0 &&
        changeBaselineRatesWorkState && Object.keys(changeBaselineRatesWorkState).length > 0) &&
            <Table className='viewmyworktable'>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>
                            Outcome
                        </Table.HeaderCell>
                        <Table.HeaderCell>
                            Baseline Risk (as %)
                        </Table.HeaderCell>
                        <Table.HeaderCell>
                            Change Baseline Risk (as %)
                        </Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {(outcomeVariables && Object.keys(outcomeVariables).length > 0 &&
                        Object.keys(changeBaselineRatesWorkState).length > 0) &&
                        Object.keys(outcomeVariables).map((targetfoi) => {
                            let item = outcomeVariables[targetfoi];
                            let startingModifiedRisk = "";
                            if (changeBaselineRatesWorkState[item.id]["modifiedRisk"] ||
                                changeBaselineRatesWorkState[item.id]["modifiedRisk"] === 0) {
                                startingModifiedRisk = parseFloat((changeBaselineRatesWorkState[item.id]["modifiedRisk"] * 100).toFixed(2)).toString();
                            }
                            return <Table.Row key={targetfoi}>
                                <Table.Cell>
                                    <a href={item.id && "/resources/EvidenceVariable/" + item.id.toString()}
                                        target="_blank" rel="noopener noreferrer" >
                                        {item.title.replace("OutcomeDefinition: ", "").replace("OutcomeVariable: ", "")}
                                    </a>
                                </Table.Cell>
                                <Table.Cell>
                                    {parseFloat((changeBaselineRatesWorkState[item.id].defaultRisk).toFixed(2))}%
                                </Table.Cell>
                                <Table.Cell>
                                    <ModifiedRiskEntry targetfoi={item.id}
                                        setChangeBaselineRatesWorkState={setChangeBaselineRatesWorkState}
                                        fieldLabel={'Risk without treatment (as %)'}
                                        startingValue={startingModifiedRisk}
                                        setChangeAvailableToSaveState={setChangeAvailableToSaveState} />
                                </Table.Cell>
                            </Table.Row>
                        })}
                </Table.Body>
            </Table>}
    </>
}

const loadChangeBaselineRatesWork = async (dispatch, targetResources,
    baselineRiskResources, apiToken, setChangeBaselineRatesWorkState) => {
    dispatch(globalLoadingOn());
    let baselineRiskDictionary = {};
    for (let item of baselineRiskResources) {
        baselineRiskDictionary[item.id] = item;
    }
    let workingBaselineRiskResourceDictionary = {};

    for (let resource of targetResources) {
        let foi = resource.id;
        if (!foi && resource.fli) {
            let trimmedFli = resource.fli.trim();
            let response2 = await getFoiFromFli(trimmedFli, apiToken);
            if (response2?.success) {
                foi = response2.formstateid;
            }
        }
        workingBaselineRiskResourceDictionary[foi] = {
            "exists": false, "targettitle": resource.title,
            "targettitleTrimmed": resource.title.replace("OutcomeDefinition: ", ""),
            "baselineRiskResource": "", "baselineRiskFoi": "", "baselineRiskEditPermission": false,
            "baselineRiskTitle": "", "baselineRiskReference": "", "defaultRisk": "",
            "modifiedRisk": ""
        };
        if (baselineRiskDictionary[foi]) {
            workingBaselineRiskResourceDictionary[foi].exists = true;
            workingBaselineRiskResourceDictionary[foi].baselineRiskResource = baselineRiskDictionary[foi].resource;
            workingBaselineRiskResourceDictionary[foi].baselineRiskFoi = baselineRiskDictionary[foi].baselineRiskFoi;
            workingBaselineRiskResourceDictionary[foi].baselineRiskEditPermission = baselineRiskDictionary[foi].editPermission;
            workingBaselineRiskResourceDictionary[foi].baselineRiskTitle = baselineRiskDictionary[foi].resource.title || baselineRiskDictionary[foi].resource.name;
            workingBaselineRiskResourceDictionary[foi].baselineRiskReference = baselineRiskDictionary[foi].reference;
            workingBaselineRiskResourceDictionary[foi].defaultRisk = baselineRiskDictionary[foi].controlEventRate;
        }
    }
    setChangeBaselineRatesWorkState(workingBaselineRiskResourceDictionary);
    dispatch(globalLoadingOff());
};

const saveChanges = async (changeBaselineRatesWorkState, setChangeBaselineRatesWorkState,
    userName, apiToken, connectionId, setSaveChangesState, setChangeAvailableToSaveState, setChangeBaselineRiskEstimatesModalState,
    dispatch, baselineRiskResources, setTriggerReloadState
) => {
    // baselineRiskResources look like  { id: targetFoi, targetTitle, baselineRiskFoi, fli, editPermission,
    //             controlEventRate, controlEventRateDisplay, resource, reference }
    let baselineRiskDictionary = {};
    for (let item of baselineRiskResources) {
        baselineRiskDictionary[item.id] = item;
    }
    for (const key in changeBaselineRatesWorkState) {
        const item = changeBaselineRatesWorkState[key];
        // where changeBaselineRatesWorkState uses foi of EvidenceVariable as key and item is object with
        //    {
        //    "exists": boolean, "targettitle": resource.title,
        //    "targettitleTrimmed": resource.title.replace("OutcomeDefinition: ", ""),
        //    "baselineRiskResource": "", "baselineRiskFoi": "", "baselineRiskEditPermission": boolean,
        //    "baselineRiskTitle": "", "baselineRiskReference": "", "defaultRisk": "",
        //    "modifiedRisk": "", "itemChanged": boolean
        //    }
        if (item.itemChanged) {
            if (!item.exists) {
                let newComparatorOnlyEvidence = {
                    "resourceType": "Evidence",
                    "meta": {
                        "profile": [
                            "http://hl7.org/fhir/uv/ebm/StructureDefinition/comparator-only-evidence"
                        ]
                    },
                    "title": "Baseline risk of " + item.targettitleTrimmed + " for " + userName,
                    "status": "active",
                    "author": [
                        {
                            "name": userName
                        }
                    ],
                    "variableDefinition": [
                        {
                            "description": userName,
                            "variableRole": "population",
                            "intended": {
                                "display": "selected by " + userName
                            }
                        },
                        {
                            "description": item.targettitleTrimmed,
                            "variableRole": "outcome",
                            "observed": {
                                "reference": "EvidenceVariable/" + key,
                                "type": "EvidenceVariable",
                                "display": item.targettitle
                            }
                        }
                    ],
                    "statistic": [
                        {
                            "statisticType": {
                                "coding": [
                                    {
                                        "system": "https://fevir.net/sevco",
                                        "code": "STATO:0000607",
                                        "display": "proportion"
                                    }
                                ]
                            },
                            "quantity": {
                                "value": item.modifiedRisk
                            }
                        }
                    ]
                }
                let response = await submitFhirJson(newComparatorOnlyEvidence,
                    newComparatorOnlyEvidence.title,
                    apiToken, "active", key, 'SummaryOfFindingsAuthoringTool');
                if (response?.success) {
                    let newFOI = response.formstateid;
                    let riskBody = {
                        id: key,
                        targetTitle: item.targettitle,
                        baselineRiskFoi: newFOI,
                        fli: "",
                        editPermission: true,
                        controlEventRate: item.modifiedRisk * 100,
                        controlEventRateDisplay: parseFloat(item.modifiedRisk * 100).toFixed(2) + "%",
                        resource: newComparatorOnlyEvidence,
                        reference: {
                            "reference": "Evidence/" + newFOI,
                            "type": "Evidence",
                            "display": newComparatorOnlyEvidence.title
                        }
                    }
                    dispatch(baselineRiskAdded(riskBody));
                } else {
                    alert("Problem submitting ComparatorOnlyEvidence for FOI " + key);
                }
                setChangeBaselineRatesWorkState(prevState => {
                    let newDictionary = JSON.parse(JSON.stringify(prevState));
                    for (let key in newDictionary) {
                        if (newDictionary[key].defaultRisk === null) {
                            newDictionary[key].defaultRisk = NaN;
                        }
                    }
                    newDictionary[key]["exists"] = true;
                    newDictionary[key]["itemChanged"] = false;
                    return newDictionary;
                });
            }
            if (item.exists) {
                let updatedResource = updateResourceWithModifiedRisks(item.baselineRiskResource, item.modifiedRisk);
                let riskBody = {
                    id: key,
                    targetTitle: item.targettitle,
                    baselineRiskFoi: item.baselineRiskFoi,
                    fli: "",
                    editPermission: true,
                    controlEventRate: item.modifiedRisk * 100,
                    controlEventRateDisplay: parseFloat(item.modifiedRisk * 100).toFixed(2) + "%",
                    resource: updatedResource,
                    reference: {
                        "reference": "Evidence/" + item.baselineRiskFoi,
                        "type": "Evidence",
                        "display": updatedResource.title
                    }
                }
                let serverResponseReference;
                if (baselineRiskDictionary[key].editPermission) {
                    dispatch(baselineRiskUpdated(riskBody));
                    let response = await updateFhirJson(item.baselineRiskFoi, updatedResource,
                        updatedResource.title, apiToken, connectionId, "active", key, 'SummaryOfFindingsAuthoringTool');
                    if (response?.success) {
                        serverResponseReference = riskBody.reference;
                    }
                } else {
                    let response = await submitFhirJson(updatedResource,
                        updatedResource.title,
                        apiToken, "active", key, 'SummaryOfFindingsAuthoringTool');
                    if (response?.success) {
                        let newFOI = response.formstateid;
                        riskBody.baselineRiskFoi = newFOI;
                        riskBody.reference.reference = "Evidence/" + newFOI;
                        dispatch(baselineRiskAdded(riskBody));
                        serverResponseReference = riskBody.reference;
                    }
                }

                if (!serverResponseReference) {
                        alert("Problem updating ComparatorOnlyEvidence for FOI " + key);
                }
                setChangeBaselineRatesWorkState(prevState => {
                    let newDictionary = JSON.parse(JSON.stringify(prevState));
                    for (let key in newDictionary) {
                        if (newDictionary[key].defaultRisk === null) {
                            newDictionary[key].defaultRisk = NaN;
                        }
                    }
                    newDictionary[key]["exists"] = true;
                    newDictionary[key]["itemChanged"] = false;
                    return newDictionary;
                });
            }
        }
    }
    if (setTriggerReloadState) {
        console.log("setTriggerReloadState to true from ChangeBaselineRiskEstimates")
        setTriggerReloadState(true);
    }
    setSaveChangesState(false);
    setChangeAvailableToSaveState(false);
    setChangeBaselineRiskEstimatesModalState(prevState => { return { ...prevState, modalOpen: false }; });
};

const ChangeBaselineRiskEstimatesModal = ({ changeBaselineRiskEstimatesModalState,
    setChangeBaselineRiskEstimatesModalState, setTriggerReloadState }) => {

    const dispatch = useDispatch();
    const connectionId = useSelector(selectSseConnectionId);
    const apiToken = useSelector(selectCurrentUserApiToken);
    const userName = useSelector(selectCurrentUserName);
    const baselineRiskResources = useSelector(state => selectAllBaselineRisks(state));
    const outcomeVariables = useSelector(state => selectAllOutcomeVariables(state));
    const targetResources = Object.keys(outcomeVariables).map(targetfoi => { return outcomeVariables[targetfoi] });

    const [changeBaselineRatesWorkState, setChangeBaselineRatesWorkState] = useState({});
    const [saveChangesState, setSaveChangesState] = useState(false);
    const [changeAvailableToSaveState, setChangeAvailableToSaveState] = useState(false);

    useEffect(() => {
        loadChangeBaselineRatesWork(dispatch, targetResources,
            baselineRiskResources, apiToken, setChangeBaselineRatesWorkState);
    }, []);

    useEffect(() => {
        if (saveChangesState === true && baselineRiskResources &&
          setTriggerReloadState) {
            saveChanges(changeBaselineRatesWorkState, setChangeBaselineRatesWorkState,
                userName, apiToken, connectionId, setSaveChangesState, setChangeAvailableToSaveState, setChangeBaselineRiskEstimatesModalState,
                dispatch, baselineRiskResources, setTriggerReloadState);
        }
    }, [saveChangesState]);

    let modalContent = <div style={{
        paddingTop: "0px", paddingLeft: "20px", paddingRight: "20px",
        paddingBottom: "40px", width: "100%", height: "100%", overflow: "auto"
    }}>
        <span style={{
            position: "absolute", backgroundColor: "#FFFFFF", width: "calc(90vw - 38px)", zIndex: 100,
            paddingTop: "6px", paddingBottom: "6px"
        }} >
            <Button style={{
                color: changeAvailableToSaveState ? "#FFFFFF" : "#000000",
                width: "230px", float: "left"
            }}
                className="formButton" disabled={saveChangesState}
                content="Save Changes" positive={changeAvailableToSaveState}
                onClick={() => {
                    setSaveChangesState(true);
                }}
            />
            &nbsp;&nbsp;&nbsp;
            <Button style={{ color: "#000000", width: "180px", float: "right" }}
                className="formButton"
                content="Close Window"
                onClick={() => {
                    setChangeBaselineRiskEstimatesModalState(prevState => { return { ...prevState, modalOpen: false }; });
                }}
            />
        </span>
        <br /><br /><br />
        <div className='tableFixHead'>
            <ChangeBaselineRatesTable changeBaselineRatesWorkState={changeBaselineRatesWorkState}
                setChangeBaselineRatesWorkState={setChangeBaselineRatesWorkState}
                setChangeAvailableToSaveState={setChangeAvailableToSaveState} />
        </div>
        <br /><br />
    </div>;

    return <>
        <Modal
            style={{ padding: "0px", margin: "0px" }}
            dimmer={<Modal.Dimmer style={{ backgroundColor: "#00000077" }} />}
            open={changeBaselineRiskEstimatesModalState?.modalOpen}
            centered={false}
            content={modalContent}
            className="viewmywork"
        />
    </>
}

const ChangeBaselineRiskEstimates = ({ setTriggerReloadState }) => {
    const apiToken = useSelector(selectCurrentUserApiToken);
    const viewingOlderVersion = useSelector(state => selectViewingOlderVersion(state));
    const baselineRiskResources = useSelector(state => selectAllBaselineRisks(state));

    const [changeBaselineRiskEstimatesModalState, setChangeBaselineRiskEstimatesModalState] = useState({ "modalOpen": false });

    return <>
        {(baselineRiskResources && Object.keys(baselineRiskResources).length > 0) &&
            <>
                {changeBaselineRiskEstimatesModalState.modalOpen &&
                    <ChangeBaselineRiskEstimatesModal 
                        changeBaselineRiskEstimatesModalState={changeBaselineRiskEstimatesModalState}
                        setChangeBaselineRiskEstimatesModalState={setChangeBaselineRiskEstimatesModalState}
                        setTriggerReloadState={setTriggerReloadState} />
                }
                <span>
                    <Button className="formButton" style={{ color: "#000000", width: "220px" }}
                        content="Change Baseline Risk Estimates"
                        onClick={() => {
                            if (apiToken) {
                                setChangeBaselineRiskEstimatesModalState({ "modalOpen": true });
                            } else {
                                alert("Please login to use this function.");
                            }
                        }}
                        disabled={viewingOlderVersion}
                    />
                    &nbsp;&nbsp;&nbsp;
                    <>
                        Add individualized estimates for the baseline risk (risk without treatment) for any of the outcomes, entered as a percentage (from 0 to 100).
                    </>
                </span>
            </>}
    </>
};

export default ChangeBaselineRiskEstimates;